/**
 * Gift Cards - Automated Messages Settings
 * Configure emails sent for online and staff-sent digital gift cards.
 */

import { createFileRoute, useParams } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SettingsPageHeader } from '@/components/ui'
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell'
import { GiftCardsTimeline } from './automated-messages/components/gift-cards-timeline'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_auth/$orgId/settings/automated-messages/gift-cards')({
  component: GiftCardsPage,
})

function GiftCardsPage() {
  const { orgId } = useParams({
    from: '/_auth/$orgId/settings/automated-messages/gift-cards',
  })

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Gift Cards', 'Automated Messages')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="gift-cards">
        <SettingsPageHeader
          title="Gift Cards"
          description="Customize messages for gift cards sold online or in-person/staff sent."
        />

        <div className="max-w-3xl">
          <GiftCardsTimeline />
        </div>
      </BusinessSetupPageShell>
    </>
  )
}
